<template>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>DECLARAÇÃO - Conceito e finalidade&nbsp;</strong></span></span
    >
  </p>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>Estrutura</strong></span></span
    >
  </p>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§&nbsp;2º&nbsp;A&nbsp;declaração&nbsp;deve&nbsp;apresentar&nbsp;as&nbsp;informações&nbsp;da&nbsp;estrutura&nbsp;detalhada&nbsp;abaixo,&nbsp;em&nbsp;forma&nbsp;de&nbsp;itens&nbsp;ou&nbsp;texto&nbsp;corrido:</strong></span></span
    >
  </p>
  <ol style="list-style-type: upper-roman">
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"
          ><span lang="PT" dir="ltr">Título: <strong>"Declaração"</strong>.&nbsp;</span></span
        >
      </p>
    </li>
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Expor&nbsp;no&nbsp;texto:</span></span>
      </p>
    </li>

    <ol style="list-style-type: lower-latin">
      <li>
        <p style="text-align: justify">
          <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">&nbsp; &nbsp; &nbsp; Nome&nbsp;da&nbsp;pessoa&nbsp;atendida:&nbsp;identificação&nbsp;do&nbsp;nome&nbsp;completo&nbsp;ou&nbsp;nome&nbsp;social&nbsp;completo;</span></span>
        </p>
      </li>
      <li>
        <p style="text-align: justify">
          <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">&nbsp; &nbsp; &nbsp; Finalidade:&nbsp;descrição&nbsp;da&nbsp;razão&nbsp;ou&nbsp;motivo&nbsp;do&nbsp;documento;</span></span>
        </p>
      </li>
      <li>
        <p style="text-align: justify">
          <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">&nbsp; &nbsp; &nbsp; Informações&nbsp;sobre&nbsp;local,&nbsp;dias,&nbsp;horários&nbsp;e&nbsp;duração&nbsp;do&nbsp;acompanhamento&nbsp;psicológico.</span></span>
        </p>
      </li>
    </ol>

    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">O documento deve ser encerrado com indicação do local, data de emissão, carimbo, em&nbsp;que conste nome completo ou nome social completo da(o) psicóloga(o), acrescido de sua&nbsp;inscrição&nbsp;profissional e assinatura.</span></span>
      </p>
    </li>
  </ol>
</template>
